import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, memo } from "react";
import { Overlay } from "../Overlay";
var BottomNav = function(_param) {
    var _items = _param.items, items = _items === void 0 ? [] : _items, _activeItem = _param.activeItem, activeItem = _activeItem === void 0 ? "" : _activeItem, _activeSubItem = _param.activeSubItem, activeSubItem = _activeSubItem === void 0 ? "" : _activeSubItem, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "activeSubItem"
    ]);
    var ref = useState({}), menuOpenByIndex = ref[0], setMenuOpenByIndex = ref[1];
    var isBottomMenuOpen = Object.values(menuOpenByIndex).some(function(acc) {
        return acc;
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isBottomMenuOpen && /*#__PURE__*/ _jsx(Overlay, {})
    });
};
export default /*#__PURE__*/ memo(BottomNav);
